import { render, staticRenderFns } from "./ChildrenPanel.vue?vue&type=template&id=4c32bd3c&scoped=true&"
import script from "./ChildrenPanel.vue?vue&type=script&lang=ts&"
export * from "./ChildrenPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ChildrenPanel.vue?vue&type=style&index=0&id=4c32bd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32bd3c",
  null
  
)

export default component.exports